//export  const APIURL = "http://127.0.0.1:8000"

// export const APIURL = "http://ec2-16-16-99-137.eu-north-1.compute.amazonaws.com"
 export const APIURL = "https://stagingapi.lacoli.eu"
